jQuery( document ).ready( function ( $ ) {
	class GROUPBLOCK {
		constructor( context ) {
			console.log( '[JTF Gut Block - JS] jtf/jtf-group v1.0' )
			this.instance = context
			this.onActionEvents()
		}
		
		onActionEvents() {
			const self = this;
			
			$( window ).on( 'resize scroll', function () {
				$( '.jtf__animation' ).each( function () {
					if ( self.isInViewport( $( this ) ) === true ) {
						$(this).addClass('jtf__animation--' + $(this).attr('data-animation'))
					}
				} )
			} )
		}
		
		isInViewport( target ) {
			var elementTop = target.offset().top
			var viewportTop = $( window ).scrollTop()
			var viewportBottom = viewportTop + $( window ).height()
			
			return elementTop < viewportBottom ? true : false
		}
	}
	
	if ( $( '.wp-block-jtf-jtf-group' ).length > 0 ) {
		$( '.wp-block-jtf-jtf-group' ).each( function () {
			new GROUPBLOCK( $( this ) )
		} )
	}
} )
